import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Progressbar Default"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", {
                class: "progress mb-3",
                role: "progressbar",
                "aria-label": "Basic example",
                "aria-valuenow": "0",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                _createElementVNode("div", {
                  class: "progress-bar",
                  style: {"width":"0%"}
                })
              ]),
              _createElementVNode("div", {
                class: "progress mb-3",
                role: "progressbar",
                "aria-label": "Basic example",
                "aria-valuenow": "25",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                _createElementVNode("div", {
                  class: "progress-bar",
                  style: {"width":"25%"}
                })
              ]),
              _createElementVNode("div", {
                class: "progress mb-3",
                role: "progressbar",
                "aria-label": "Basic example",
                "aria-valuenow": "50",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                _createElementVNode("div", {
                  class: "progress-bar",
                  style: {"width":"50%"}
                })
              ]),
              _createElementVNode("div", {
                class: "progress mb-3",
                role: "progressbar",
                "aria-label": "Basic example",
                "aria-valuenow": "75",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                _createElementVNode("div", {
                  class: "progress-bar",
                  style: {"width":"75%"}
                })
              ]),
              _createElementVNode("div", {
                class: "progress mb-3",
                role: "progressbar",
                "aria-label": "Basic example",
                "aria-valuenow": "100",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                _createElementVNode("div", {
                  class: "progress-bar",
                  style: {"width":"100%"}
                })
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode"
                }, "\n<div class=\"progress mb-3\" role=\"progressbar\" aria-label=\"Basic example\" aria-valuenow=\"0\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n<div class=\"progress-bar\" style=\"width: 0%\"></div>\n</div>\n<div class=\"progress mb-3\" role=\"progressbar\" aria-label=\"Basic example\" aria-valuenow=\"25\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n<div class=\"progress-bar\" style=\"width: 25%\"></div>\n</div>\n<div class=\"progress mb-3\" role=\"progressbar\" aria-label=\"Basic example\" aria-valuenow=\"50\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n<div class=\"progress-bar\" style=\"width: 50%\"></div>\n</div>\n<div class=\"progress mb-3\" role=\"progressbar\" aria-label=\"Basic example\" aria-valuenow=\"75\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n<div class=\"progress-bar\" style=\"width: 75%\"></div>\n</div>\n<div class=\"progress mb-3\" role=\"progressbar\" aria-label=\"Basic example\" aria-valuenow=\"100\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n<div class=\"progress-bar\" style=\"width: 100%\"></div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Progressbar Heigh"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab2",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview2-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code2-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent2"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", {
                class: "progress mb-3",
                role: "progressbar",
                "aria-label": "Example 1px high",
                "aria-valuenow": "25",
                "aria-valuemin": "0",
                "aria-valuemax": "100",
                style: {"height":"1px"}
              }, [
                _createElementVNode("div", {
                  class: "progress-bar",
                  style: {"width":"25%"}
                })
              ]),
              _createElementVNode("div", {
                class: "progress",
                role: "progressbar",
                "aria-label": "Example 20px high",
                "aria-valuenow": "25",
                "aria-valuemin": "0",
                "aria-valuemax": "100",
                style: {"height":"20px"}
              }, [
                _createElementVNode("div", {
                  class: "progress-bar",
                  style: {"width":"25%"}
                })
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode2"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode2"
                }, "\n<div class=\"progress mb-3\" role=\"progressbar\" aria-label=\"Example 1px high\" aria-valuenow=\"25\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"height: 1px\">\n<div class=\"progress-bar\" style=\"width: 25%\"></div>\n</div>\n<div class=\"progress\" role=\"progressbar\" aria-label=\"Example 20px high\" aria-valuenow=\"25\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"height: 20px\">\n<div class=\"progress-bar\" style=\"width: 25%\"></div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Progressbar Labels"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab3",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview3-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code3-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent3"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", {
                class: "progress",
                role: "progressbar",
                "aria-label": "Example with label",
                "aria-valuenow": "25",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                _createElementVNode("div", {
                  class: "progress-bar",
                  style: {"width":"25%"}
                }, "25%")
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode3"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode3"
                }, "\n<div class=\"progress\" role=\"progressbar\" aria-label=\"Example with label\" aria-valuenow=\"25\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n<div class=\"progress-bar\" style=\"width: 25%\">25%</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Progressbar Labels Text"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab4",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview4-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview4-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview4-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code4-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code4-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code4-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent4"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview4-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview4-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", {
                class: "progress",
                role: "progressbar",
                "aria-label": "Example with label",
                "aria-valuenow": "10",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                _createElementVNode("div", {
                  class: "progress-bar overflow-visible text-dark",
                  style: {"width":"10%"}
                }, " Long label text for the progress bar, set to a dark color ")
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code4-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code4-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode4"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode4"
                }, "\n<div class=\"progress\" role=\"progressbar\" aria-label=\"Example with label\" aria-valuenow=\"10\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n<div class=\"progress-bar overflow-visible text-dark\" style=\"width: 10%\">Long label text for the progress bar, set to a dark color</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Progressbar Backgrounds"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab5",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview5-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview5-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview5-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code5-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code5-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code5-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent5"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview5-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview5-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", {
                class: "progress mb-3",
                role: "progressbar",
                "aria-label": "Success example",
                "aria-valuenow": "25",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                _createElementVNode("div", {
                  class: "progress-bar bg-success",
                  style: {"width":"25%"}
                })
              ]),
              _createElementVNode("div", {
                class: "progress mb-3",
                role: "progressbar",
                "aria-label": "Info example",
                "aria-valuenow": "50",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                _createElementVNode("div", {
                  class: "progress-bar bg-info",
                  style: {"width":"50%"}
                })
              ]),
              _createElementVNode("div", {
                class: "progress mb-3",
                role: "progressbar",
                "aria-label": "Warning example",
                "aria-valuenow": "75",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                _createElementVNode("div", {
                  class: "progress-bar bg-warning",
                  style: {"width":"75%"}
                })
              ]),
              _createElementVNode("div", {
                class: "progress mb-0",
                role: "progressbar",
                "aria-label": "Danger example",
                "aria-valuenow": "100",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                _createElementVNode("div", {
                  class: "progress-bar bg-danger",
                  style: {"width":"100%"}
                })
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code5-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code5-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode5"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode5"
                }, "\n<div class=\"progress mb-3\" role=\"progressbar\" aria-label=\"Success example\" aria-valuenow=\"25\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n<div class=\"progress-bar bg-success\" style=\"width: 25%\"></div>\n</div>\n<div class=\"progress mb-3\" role=\"progressbar\" aria-label=\"Info example\" aria-valuenow=\"50\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n<div class=\"progress-bar bg-info\" style=\"width: 50%\"></div>\n</div>\n<div class=\"progress mb-3\" role=\"progressbar\" aria-label=\"Warning example\" aria-valuenow=\"75\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n<div class=\"progress-bar bg-warning\" style=\"width: 75%\"></div>\n</div>\n<div class=\"progress mb-0\" role=\"progressbar\" aria-label=\"Danger example\" aria-valuenow=\"100\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n<div class=\"progress-bar bg-danger\" style=\"width: 100%\"></div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Progressbar Backgrounds Label"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab6",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview6-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview6-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview6-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code6-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code6-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code6-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent6"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview6-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview6-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", {
                class: "progress mb-3",
                role: "progressbar",
                "aria-label": "Success example",
                "aria-valuenow": "25",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                _createElementVNode("div", {
                  class: "progress-bar bg-success",
                  style: {"width":"25%"}
                }, " 25% ")
              ]),
              _createElementVNode("div", {
                class: "progress mb-3",
                role: "progressbar",
                "aria-label": "Info example",
                "aria-valuenow": "50",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                _createElementVNode("div", {
                  class: "progress-bar bg-info text-dark",
                  style: {"width":"50%"}
                }, " 50% ")
              ]),
              _createElementVNode("div", {
                class: "progress mb-3",
                role: "progressbar",
                "aria-label": "Warning example",
                "aria-valuenow": "75",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                _createElementVNode("div", {
                  class: "progress-bar bg-warning text-dark",
                  style: {"width":"75%"}
                }, " 75% ")
              ]),
              _createElementVNode("div", {
                class: "progress",
                role: "progressbar",
                "aria-label": "Danger example",
                "aria-valuenow": "100",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                _createElementVNode("div", {
                  class: "progress-bar bg-danger",
                  style: {"width":"100%"}
                }, " 100% ")
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code6-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code6-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode6"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode6"
                }, "\n<div class=\"progress\" role=\"progressbar\" aria-label=\"Success example\" aria-valuenow=\"25\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n<div class=\"progress-bar bg-success\" style=\"width: 25%\">25%</div>\n</div>\n<div class=\"progress\" role=\"progressbar\" aria-label=\"Info example\" aria-valuenow=\"50\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n<div class=\"progress-bar bg-info text-dark\" style=\"width: 50%\">50%</div>\n</div>\n<div class=\"progress\" role=\"progressbar\" aria-label=\"Warning example\" aria-valuenow=\"75\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n<div class=\"progress-bar bg-warning text-dark\" style=\"width: 75%\">75%</div>\n</div>\n<div class=\"progress\" role=\"progressbar\" aria-label=\"Danger example\" aria-valuenow=\"100\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n<div class=\"progress-bar bg-danger\" style=\"width: 100%\">100%</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Progressbar Multiple bars"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab7",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview7-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview7-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview7-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code7-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code7-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code7-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent7"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview7-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview7-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "progress-stacked" }, [
                _createElementVNode("div", {
                  class: "progress",
                  role: "progressbar",
                  "aria-label": "Segment one",
                  "aria-valuenow": "15",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100",
                  style: {"width":"15%"}
                }, [
                  _createElementVNode("div", { class: "progress-bar" })
                ]),
                _createElementVNode("div", {
                  class: "progress",
                  role: "progressbar",
                  "aria-label": "Segment two",
                  "aria-valuenow": "30",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100",
                  style: {"width":"30%"}
                }, [
                  _createElementVNode("div", { class: "progress-bar bg-success" })
                ]),
                _createElementVNode("div", {
                  class: "progress",
                  role: "progressbar",
                  "aria-label": "Segment three",
                  "aria-valuenow": "20",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100",
                  style: {"width":"20%"}
                }, [
                  _createElementVNode("div", { class: "progress-bar bg-info" })
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code7-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code7-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode7"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode7"
                }, "\n<div class=\"progress-stacked\">\n<div class=\"progress\" role=\"progressbar\" aria-label=\"Segment one\" aria-valuenow=\"15\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 15%\">\n<div class=\"progress-bar\"></div>\n</div>\n<div class=\"progress\" role=\"progressbar\" aria-label=\"Segment two\" aria-valuenow=\"30\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 30%\">\n<div class=\"progress-bar bg-success\"></div>\n</div>\n<div class=\"progress\" role=\"progressbar\" aria-label=\"Segment three\" aria-valuenow=\"20\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 20%\">\n<div class=\"progress-bar bg-info\"></div>\n</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Progressbar Striped"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab8",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview8-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview8-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview8-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code8-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code8-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code8-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent8"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview8-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview8-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", {
                class: "progress mb-3",
                role: "progressbar",
                "aria-label": "Default striped example",
                "aria-valuenow": "10",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                _createElementVNode("div", {
                  class: "progress-bar progress-bar-striped",
                  style: {"width":"10%"}
                })
              ]),
              _createElementVNode("div", {
                class: "progress mb-3",
                role: "progressbar",
                "aria-label": "Success striped example",
                "aria-valuenow": "25",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                _createElementVNode("div", {
                  class: "progress-bar progress-bar-striped bg-success",
                  style: {"width":"25%"}
                })
              ]),
              _createElementVNode("div", {
                class: "progress mb-3",
                role: "progressbar",
                "aria-label": "Info striped example",
                "aria-valuenow": "50",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                _createElementVNode("div", {
                  class: "progress-bar progress-bar-striped bg-info",
                  style: {"width":"50%"}
                })
              ]),
              _createElementVNode("div", {
                class: "progress mb-3",
                role: "progressbar",
                "aria-label": "Warning striped example",
                "aria-valuenow": "75",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                _createElementVNode("div", {
                  class: "progress-bar progress-bar-striped bg-warning",
                  style: {"width":"75%"}
                })
              ]),
              _createElementVNode("div", {
                class: "progress mb-0",
                role: "progressbar",
                "aria-label": "Danger striped example",
                "aria-valuenow": "100",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                _createElementVNode("div", {
                  class: "progress-bar progress-bar-striped bg-danger",
                  style: {"width":"100%"}
                })
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code8-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code8-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode8"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode8"
                }, "\n<div class=\"progress mb-3\" role=\"progressbar\" aria-label=\"Default striped example\" aria-valuenow=\"10\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n<div class=\"progress-bar progress-bar-striped\" style=\"width: 10%\"></div>\n</div>\n<div class=\"progress mb-3\" role=\"progressbar\" aria-label=\"Success striped example\" aria-valuenow=\"25\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n<div class=\"progress-bar progress-bar-striped bg-success\" style=\"width: 25%\"></div>\n</div>\n<div class=\"progress mb-3\" role=\"progressbar\" aria-label=\"Info striped example\" aria-valuenow=\"50\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n<div class=\"progress-bar progress-bar-striped bg-info\" style=\"width: 50%\"></div>\n</div>\n<div class=\"progress mb-3\" role=\"progressbar\" aria-label=\"Warning striped example\" aria-valuenow=\"75\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n<div class=\"progress-bar progress-bar-striped bg-warning\" style=\"width: 75%\"></div>\n</div>\n<div class=\"progress mb-0\" role=\"progressbar\" aria-label=\"Danger striped example\" aria-valuenow=\"100\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n<div class=\"progress-bar progress-bar-striped bg-danger\" style=\"width: 100%\"></div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Progressbar Animated stripes"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab9",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview9-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview9-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview9-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code9-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code9-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code9-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent9"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview9-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview9-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", {
                class: "progress",
                role: "progressbar",
                "aria-label": "Animated striped example",
                "aria-valuenow": "75",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, [
                _createElementVNode("div", {
                  class: "progress-bar progress-bar-striped progress-bar-animated",
                  style: {"width":"75%"}
                })
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code9-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code9-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode9"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode9"
                }, "\n<div class=\"progress\" role=\"progressbar\" aria-label=\"Animated striped example\" aria-valuenow=\"75\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n<div class=\"progress-bar progress-bar-striped progress-bar-animated\" style=\"width: 75%\"></div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ]))]))
}